import { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { MicrosoftTable } from 'components/Tables/MicrosoftTable';
// import { useLocation } from 'react-router-dom';

const Microsoft: FC = observer(() => {
  // const location = useLocation();

  // useEffect(() => {
  //   const queryParams = new URLSearchParams(location.search);
  //   const token = queryParams.get('token');
  //   if (token) {
  //     localStorage.setItem('token', `Bearer ${token}`);
  //   }
  // }, [location.search]);

  return <MicrosoftTable />;
});

export default Microsoft;
